<script setup>
definePage({ meta: { ...PageMeta.Orders.Preview.Meta, pageTitle: 'Order' } })

import { canRecord } from '@/@layouts/plugins/casl'
import OrdersServicePage from '@/views/Previews/Orders/OrdersServicePage.vue'
import OrdersVerticalSidebar from '@/views/Previews/Orders/OrdersVerticalSidebar.vue'
import { useOrderStore } from '@/@vxapp/Orders/useOrderStore'
import { useRoute } from 'vue-router'
import { Action } from '@/@vxapp/@Enums/PHP/Auth/DataProviders/AbilityAction'
import { Subject } from '@/@vxapp/@Enums/PHP/Auth/Ability/Subjects/DataProviders/AbilitySubject'
import { OrderField } from '@/@vxapp/@Enums/PHP/ServicesV2/Orders/DataProviders/OrderField'
import { useEntityPageTitle } from '@/composables/useEntityPageTitle'

const route = useRoute()
const orderStore = useOrderStore()

useEntityPageTitle({
  entityName: 'Order',
  record: () => orderStore.order,
  recordGuid: order => order.orderGUID,
  identifier: order =>
    canRecord(Action.READ, Subject.ORDERS_PREVIEW_GUID, order, OrderField.DB_IDENTIFIER)
      ? order.id
      : null,
})

/* ****** */
</script>

<template>
  <section>
    <VRow>
      <VCol
        cols="12"
        md="9"
      >
        <OrdersServicePage
          :key="route.params.guid"
          :order-g-u-i-d="route.params.guid"
          :allow-changes="canRecord(Action.UPDATE, Subject.ORDERS_UPDATE_GUID, orderStore.order)"
          :show-gateway="false"
        />
      </VCol>

      <!-- sidebar -->
      <VCol
        cols="12"
        md="3"
      >
        <OrdersVerticalSidebar
          allow-changes
          :order-g-u-i-d="route.params.guid"
        />
      </VCol>
      <!-- -->
    </VRow>
  </section>
</template>

<style lang="scss">
.order-preview-table {
  --v-table-row-height: 44px !important;
}

@media print {
  .v-application {
    background: none !important;
  }

  @page {
    margin: 0;
    size: auto;
  }

  .layout-page-content,
  .v-row,
  .v-col-md-9 {
    padding: 0;
    margin: 0;
  }

  .product-buy-now {
    display: none;
  }

  .v-navigation-drawer,
  .layout-vertical-nav,
  .app-customizer-toggler,
  .layout-footer,
  .layout-navbar,
  .layout-navbar-and-nav-container {
    display: none;
  }

  .v-card {
    box-shadow: none !important;

    .print-row {
      flex-direction: row !important;
    }
  }

  .layout-content-wrapper {
    padding-inline-start: 0 !important;
  }
}
</style>
